import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Tiretwo = () => {

    const [, setIsScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const categories = [

        {
            name: "AKT STEEL",
            subItems: [
                { name: "STEEL STRUCTURE", link: "/division/structural-divisions" },
                { name: "STEEL PIPES", link: "/division/steel-pipes" },
                { name: "VALVE & FLANGES", link: "/division/valve-&-flanges" },
                {
                    name:"Akt Showroom and Workshops Projects",
                    Children:[
                        {
                            name:"Project Completed",link: "/division/project-completed"
                        }
                    ]
                }
            ],
        },
        {
            name: "AKT TRADING",
            subItems: [
                { name: "SEALENTS", link: "/division/Selment" },
                { name: "RTV", link: "/division/Rtv" },
                { name: "ADHESIVES", link: "/division/Adhesives" },
                // { name: "ROOF COATINGS", link: "/division/Roofcoating" },
            ],
        },
        {
            name: "AKT AUTOMOTIVE",
            subItems: [
                { name: "AKT CAR WASH", link: "/division/akt-car-works" },
                { name: "AKT CAR CARE", link: "/division/akt-car-care" },
                { name: "AKT POWDER COATING", link: "/division/powder-coating" },
                { name: "QUICK SERVICES", link: "/division/akt-quick-services" },

            ],
        },
        {
            name: "AKT TOOLS DIVISION",
            subItems: [
                { name: "AKT TOOLS", link: "/division/akt-tools-division" },
            ],
        },
       
    ];

    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <div className="">
           
                <div className="">
                    <h2 className="text-3xl font-bold mb-4 text-[#0c2341] text-center">
                        CATEGORIES
                    </h2>
                    <ul className="space-y-3">
                        {categories.map((category, index) => (
                            <div
                                key={index}
                                className="flex flex-col"
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}>
                                {/* Main Category Item */}
                                <li className="text-xl font-semibold text-[#0c2341] cursor-pointer px-4 py-1 transition duration-300 rounded-lg">
                                    {category.name}
                                </li>
                                {hoveredIndex === index && (
                                    <ul className="bg-white rounded-lg py-2 opacity-100 visible text-lg font-[18xp] ml-5">
                                        {category.subItems.map((subItem, subIndex) => {
                                            const isActive = location.pathname === subItem.link; // Check if active

                                            return (
                                                <li
                                                    key={subIndex}
                                                    className={`px-6 py-2 text-[#0c2341] hover:bg-[#0c2341] hover:text-white rounded-lg mb-1
                            ${isActive ? "bg-[#0c2341] text-white" : ""}`} // Apply active styles
                                                >
                                                    <Link to={subItem.link} className="cursor-pointer block">
                                                        {subItem.name}
                                                    </Link>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}


                            </div>
                        ))}
                    </ul>
                </div>
                
          
           
        </div>
    );
};

export default Tiretwo;
